import { createRoute } from "@tanstack/react-router";
import { RoleGuard } from "@/components/auth/RoleGuard";
import { ApiKeysAdmin } from "@/pages/admin/ApiKeysAdmin";
import { Route as RootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: "/admin/api-keys",
  component: () => (
    <RoleGuard action="api_key_crud">
      <ApiKeysAdmin />
    </RoleGuard>
  ),
});
